import { InjectionToken } from '@angular/core';

/**
 * Interface for feature toggle service to avoid direct dependency on @cbre/feature-toggles
 */
export interface FeatureToggleServiceInterface {
  isFeatureEnabled(featureKey: string): boolean;
  navigate?(url: string): void;
  getCurrentRoute?(): any;
}

/**
 * Injection token for feature toggle service
 */
export const FEATURE_TOGGLE_TOKEN = new InjectionToken<FeatureToggleServiceInterface>('FEATURE_TOGGLE_TOKEN');
